"use client";

import PageHeader from "@/components/publicWebsite/common/pageHeader";
import BlogDetilsArtical from "@/components/publicWebsite/eventDetails/eventDetailsBlog";
import RelatedBlogs from "@/components/publicWebsite/eventDetails/relatedEvents";
import { useSearchParams } from "next/navigation";
import { BlogPost, eventData } from "@/db/blogPostsData";

export default function BlogDetails() {
  const params = useSearchParams();
  const id = params.get("id");

  // ✅ find the matching event
  const post: BlogPost | undefined = eventData.find(
    (item) => item.id.toString() === id
  );

  // ✅ handle missing post
  if (!post) {
    return (
      <>
        <PageHeader title="Event Not Found" />
        <div className="py-120 text-center">
          <h3>Sorry, this event does not exist.</h3>
        </div>
      </>
    );
  }

  return (
    <>
      <PageHeader title="Event Details" image="/images/banners/c15.png"/>
      <div className="pb-120 border-bottom"></div>

      {/* ✅ pass the post */}
      <BlogDetilsArtical post={post} />
      <RelatedBlogs />
    </>
  );
}
